import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@environments/environment';


@Component({
  selector: 'kendo-grid-cell-image',
  template: `
  <img src="{{((image=='') ? defaultImage : image)}}" class="{{imgClass}}"> {{text}}`,
  styles: [`
    .img-24 {
      width: 24px;
      border-radius: 50%!important;
      margin-right: 8px;
    }
    .img-40 {
      width: 40px;
    }
    .img-200 {
      width: 200px;
    }`],
})
export class KendoGridCellImageComponent implements OnInit {  

  @Input() image: string = '';
  @Input() text: string = '';
  @Input() imgClass: string = 'img-24';

  //Input: table
  private _folder : string = '__FOLDER__';

  @Input()
  set folder(value: string) {
    this._folder = (value && value.trim());
    this.defaultImage = `${environment.apiUrl}/uploads/${this._folder}/_DEFAULT.png`;
    // console.log('set table = ' + this._table);
  }

  get folder(): string { return this._folder; }

  //Input: defaultImage
  protected defaultImage: string = '__DEFAULT_IMAGE__';

  
  constructor() { }
 
  ngOnInit() { }

}
